import {
  Box,
  Button,
  CollapsableCard,
  Icon,
  Text,
  Touchable,
} from '@factorialco/deprecated-design-system'
import { useToggle } from 'usehooks-ts'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  reason: string | null | undefined
  spendPolicyId: number
}

export const WorkflowPolicyStatusCard = ({ reason, spendPolicyId }: Props) => {
  const [showContent, toggleContent] = useToggle(true)
  const { navigation } = useNavigation()

  return (
    <CollapsableCard
      open={showContent}
      contentBackground="grey000White"
      contentPadding="s8"
      Card={
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text size="300" weight="semibold" color="radicalRed1200">
            {i18n.t('expenses_v2.expense.spending_alert.tooltip.spending_policy')}
          </Text>
          <Touchable onClick={toggleContent}>
            <Icon.Small icon={showContent ? 'chevron-up' : 'chevron-down'} color="grey800" />
          </Touchable>
        </Box>
      }
      Content={
        <Box gap="s16" paddingX="s8">
          <Text size="300" weight="semibold">
            {reason}
          </Text>
          {spendPolicyId && (
            <Button.Router
              iconName="expenses"
              type="secondary"
              to={navigation.expenses.spendingPolicies.detail.fullPath({
                policyId: spendPolicyId,
              })}
              blankTarget
            >
              {i18n.t('expenses_v2.expense.spending_alert.tooltip.view_policy')}
            </Button.Router>
          )}
        </Box>
      }
    />
  )
}
